import { writable, derived } from 'svelte/store';
import { translations } from './translations';

const STORAGE_KEY = 'app_language';
const DEFAULT_LANG = 'zh-HK';

// Initialize from local storage or default
const storedLang = localStorage.getItem(STORAGE_KEY) || DEFAULT_LANG;
export const currentLang = writable(storedLang);

// Subscribe to save changes
currentLang.subscribe(value => {
    localStorage.setItem(STORAGE_KEY, value);
});

// Derived store for translating text
// Usage in component: $t('key.name') or $t('key.name', { param: 'value' })
export const t = derived(currentLang, $lang => (key, params) => {
    let text = (translations[$lang] && translations[$lang][key] !== undefined)
        ? translations[$lang][key]
        : key;
    if (params && typeof params === 'object') {
        for (const [k, v] of Object.entries(params)) {
            text = text.replace(new RegExp(`\\{${k}\\}`, 'g'), v);
        }
    }
    return text;
});